import {
  KlevuFetch,
  KlevuTypeOfRequest,
  KlevuTypeOfRecord,
  personalisation,
  raw,
} from "@klevu/core";

export default () => ({
  active: "login",
  activeMenu: null,
  handPickedCount: "",
  favoritesCount: "",
  ordersCount: "",

  init() {
    this.activeMenu = window.location.search;
    this.setFavoritesCount();
    this.setHandPickedCount();
    this.setOrdersCount();
  },

  async setHandPickedCount() {
    let prodAmount = 0;

    let storedPickedCount = parseInt(
      sessionStorage.getItem("klevuHandPickedCount")
    );

    if (storedPickedCount) {
      prodAmount = storedPickedCount;
    } else {
      try {
        const trendingProductsForYouQuery = raw(
          {
            id: "trendingProductsForYou",
            typeOfRequest: KlevuTypeOfRequest.Trending,
            settings: {
              typeOfRecords: [KlevuTypeOfRecord.Product],
            },
          },
          personalisation()
        );
        const result = await KlevuFetch(trendingProductsForYouQuery);
        const noResults = result.apiResponse.queryResults[0].meta.noOfResults;
        prodAmount = noResults;
        sessionStorage.setItem("klevuHandPickedCount", noResults);
      } catch (error) {
        console.log(error);
      }
    }

    const recId = document.getElementById("preference-handpicked-count");

    const formattedHandPickedCount =
      prodAmount <= 9 ? "0" + prodAmount : prodAmount.toString();
    this.handPickedCount = prodAmount > 0 ? formattedHandPickedCount : "";

    if (recId) {
      recId.innerText = prodAmount > 0 ? this.handPickedCount : "0";
    }
  },

  setFavoritesCount() {
    CF.customerReady(
      function () {
        let customerFavorites = CF.customer.get("favorites_list") || [];
        let cfLength = customerFavorites.length;
        if (customerFavorites.length > 0) {
          this.favoritesCount =
            cfLength >= 1 && cfLength <= 9
              ? "0" + cfLength
              : cfLength.toString();
        } else {
          this.favoritesCount = "";
        }
      }.bind(this)
    );
  },

  setOrdersCount() {
    const url = `${shopUrl}/apps/jl-api/frontend/voyado/transactions`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        let oLength = data.count;
        if (oLength > 0) {
          this.ordersCount =
            oLength >= 1 && oLength <= 9 ? "0" + oLength : oLength.toString();
        } else {
          this.ordersCount = "";
        }
      });
  },
});
